import type {
  AuthError,
  User as SupabaseUser,
  UserMetadata as SupabaseUserMetadata,
} from '@supabase/supabase-js'

import getClient from './getClient'

const getInitials = (email = '', displayName = '') => {
  if (!email && !displayName) return null
  if (displayName === email) return email[0]

  return displayName
    .split(' ')
    .map((name: string) => name[0])
    .join('')
}

const getDisplayName = (user: SupabaseUser) => {
  let name = user?.email
  const userMetadata = user?.user_metadata

  if (userMetadata?.firstName) {
    name = userMetadata.firstName

    if (userMetadata?.lastName) {
      name += ` ${user?.user_metadata?.lastName}`
    }
  }

  return name
}

interface UserMetadata extends SupabaseUserMetadata {
  initials?: string | null
  displayName?: string
}
export interface User extends SupabaseUser {
  user_metadata: UserMetadata
}
interface UserResponse {
  user?: User
  error?: AuthError
}

export default async function getUser(): Promise<UserResponse> {
  const result = await getClient().auth.getUser()
  if (result.error) return { error: result.error }
  const user = result.data.user

  const displayName = getDisplayName(user)
  return {
    user: {
      ...user,
      user_metadata: {
        ...user.user_metadata,
        initials: getInitials(user?.email, displayName),
        displayName,
      },
    },
  }
}
